export const DragTypes = {
  BOX: 'box',
  CARD: 'card',
};
